import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { isInternalUser } from "../../constants/utils";

/**
 * Route guard for internal-ops pages (User Activity): only users whose ID token carries
 * `custom:userType = INTERNAL` pass; external users of any role are redirected.
 *
 * Nests *inside* the existing `RequirePermission permission={P.UserActivity.View}`
 * wrapper rather than replacing it. Permissions are backend-role-driven and independent
 * of user type, so the permission alone would admit an external user who is ever granted
 * it. This mirrors the `isInternalUser()` condition on the SideNav link — hiding a link is
 * not access control, and a hand-typed /user-activity URL would otherwise render the page
 * and fire the UAL search on mount.
 *
 * The user type comes from the ID token, so it resolves on the first render — there is no
 * loading window to fail open or closed on.
 */
const RequireInternalUser = ({ redirectTo = "/unauthorized" }) =>
  isInternalUser() ? <Outlet /> : <Navigate to={redirectTo} replace />;

RequireInternalUser.propTypes = {
  redirectTo: PropTypes.string,
};

export default RequireInternalUser;
